module.exports = __webpack_public_path__ + "img/part-3-title.6062030e.png";